
export const TEXT_UNMATCH = "unmatch";
export const TEXT_INCOMPLETE = "incomplete";
export const TEXT_COMPLETE = "complete";
